let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2cNaj")).then(() => parcelRequire('9HF0e'));